// changeShowcaseActiveIndex.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getShowcaseListItems from '../selector/getShowcaseListItems.js';

/**
 * Change showcase active index
 * @kind action
 * @param {number} {activeIndex} - active index.
 * @return {Promise} Action promise.
 */
const changeShowcaseActiveIndex =
  ({ activeIndex, type }) =>
  async (dispatch, getState) => {
    const state = getState();
    const featuredListingAmount =
      getShowcaseListItems(state, type)?.length || 0;

    let nextIndex = activeIndex;

    if (nextIndex < 0) {
      nextIndex = featuredListingAmount + nextIndex;
    } else if (nextIndex >= featuredListingAmount) {
      nextIndex = nextIndex % featuredListingAmount;
    }

    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['showcase'],
        data: {
          activeIndex: nextIndex,
        },
      },
    });
  };

export default changeShowcaseActiveIndex;
